import React from "react";
import {
  Container,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Paper,
  CssBaseline,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import ScrollToTopBtn from "../common/ScrollToTop";
import * as gkApi from "../../api/gkApi";

class GKCountry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      years: [],
      fromYear: "",
      toYear: "",
      fromQuarter: 1,
      toQuarter: 2,
      page: 0,
      rowsPerPage: 10,
    };
  }

  async componentDidMount() {
    try {
      const years = await gkApi.getYears();
      years.sort((a, b) => b - a);
      if (years) {
        const year = years[0];
        this.setState(
          {
            years,
            fromYear: year,
            toYear: year,
          },
          () => this.getCountries(year, year)
        );
      }
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getCountries = async (fromYear, toYear) => {
    const list = await gkApi.getCountries(
      fromYear,
      this.state.fromQuarter,
      toYear,
      this.state.toQuarter
    );
    if (list) {
      list.sort((a, b) => (a.country < b.country ? -1 : 1));
      this.setState({ list });
    } else {
      this.setState({ list: [] });
    }
  };

  handleChangePage = (_event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleChange = async (e) => {
    const { name, value } = e.target;
    await this.setState({ [name]: value });
    this.getCountries(this.state.fromYear, this.state.toYear);
  };

  handledownload = async () => {
    const { fromYear, fromQuarter, toYear, toQuarter } = this.state;
    const excelfile = await gkApi.getExcelFileCountries(
      fromYear,
      fromQuarter,
      toYear,
      toQuarter,
      true
    );
    if (!excelfile) {
      toast.error("Ingen data");
    }
  };

  render() {
    const quarters = [1, 2, 3, 4];

    const layoutStyle = {
      width: "100%",
      paddingTop: 80,
      margin: "auto",
    };

    const paperStyle = {
      width: "100%",
      padding: 20,
    };

    const tableWrapperStyle = {
      marginTop: 10,
      overflow: "auto",
    };

    const buttonStyle = {
      float: "right",
    };

    const headDarkStyle = {
      backgroundColor: "#e6e6e6",
      fontWeight: "bold",
      fontSize: 16,
    };

    const headLightStyle = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
    };

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={layoutStyle}>
            <Paper style={paperStyle}>
              <React.Fragment>
                <CssBaseline />
                <h3>
                  Grønt kort korrespondenter - meldte skader fordelt på land
                </h3>
                <Grid container>

                  <Grid container spacing={1} sx={{ flexWrap: "wrap", justifyContent: "flex-start" }}>
                    <h3 style={{ marginRight: "10px" }}>Data for:</h3>

                    <Grid item sx={{ minWidth: 80, maxWidth: 100, flexGrow: 1 }}>
                      <FormControl variant="standard" fullWidth>
                        <InputLabel>Fra år</InputLabel>
                        <Select
                          name="fromYear"
                          value={this.state.fromYear || ""}
                          onChange={this.handleChange}
                        >
                          {this.state.years.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item sx={{ minWidth: 80, maxWidth: 100, flexGrow: 1 }}>
                      <FormControl variant="standard" fullWidth>
                        <InputLabel>Kvartal</InputLabel>
                        <Select
                          name="fromQuarter"
                          value={this.state.fromQuarter || ""}
                          onChange={this.handleChange}
                        >
                          {quarters.map((quarter, index) => (
                            <MenuItem key={index} value={quarter}>
                              {quarter}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item sx={{ minWidth: 80, maxWidth: 100, flexGrow: 1 }}>
                      <FormControl variant="standard" fullWidth>
                        <InputLabel>Til år</InputLabel>
                        <Select
                          name="toYear"
                          value={this.state.toYear || ""}
                          onChange={this.handleChange}
                        >
                          {this.state.years.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item sx={{ minWidth: 80, maxWidth: 100, flexGrow: 1 }}>
                      <FormControl variant="standard" fullWidth>
                        <InputLabel>Kvartal</InputLabel>
                        <Select
                          name="toQuarter"
                          value={this.state.toQuarter || ""}
                          onChange={this.handleChange}
                        >
                          {quarters.map((quarter, index) => (
                            <MenuItem key={index} value={quarter}>
                              {quarter}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid item lg={2} style={{ paddingTop: 15, marginLeft: 60 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<CloudDownloadIcon />}
                      onClick={this.handledownload}
                      style={buttonStyle}
                    >
                      Vis i Excel
                    </Button>
                  </Grid>
                  <Grid item lg={12}>
                    {this.state.list.length > 0 ? (
                      <Paper style={{ width: "100%" }}>
                        <div style={tableWrapperStyle}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow>
                                <TableCell style={headLightStyle}>
                                  Forsikringsselskapets-
                                  <br />
                                  nasjonalitet
                                </TableCell>
                                <TableCell
                                  align="center"
                                  colSpan={3}
                                  style={headDarkStyle}
                                >
                                  Antall meldte skader
                                </TableCell>
                                <TableCell
                                  align="center"
                                  colSpan={3}
                                  style={headLightStyle}
                                >
                                  Utbetalt erstatning
                                </TableCell>
                                <TableCell
                                  align="center"
                                  colSpan={3}
                                  style={headDarkStyle}
                                >
                                  Reserve (ved utgang av perioden)
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell style={headLightStyle}></TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Person
                                </TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Materiell
                                </TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Sum
                                </TableCell>
                                <TableCell align="right" style={headLightStyle}>
                                  Person
                                </TableCell>
                                <TableCell align="right" style={headLightStyle}>
                                  Materiell
                                </TableCell>
                                <TableCell align="right" style={headLightStyle}>
                                  Sum
                                </TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Person
                                </TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Materiell
                                </TableCell>
                                <TableCell align="right" style={headDarkStyle}>
                                  Sum
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.list
                                .slice(
                                  this.state.page * this.state.rowsPerPage,
                                  this.state.page * this.state.rowsPerPage +
                                  this.state.rowsPerPage
                                )
                                .map((item, index) => (
                                  <TableRow hover key={index}>
                                    <TableCell>{item.country}</TableCell>
                                    <TableCell align="right">
                                      {item.qtyPerson.toLocaleString("de-DE")}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.qtyMaterial.toLocaleString("de-DE")}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.qtySum.toLocaleString("de-DE")}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.compensationPerson.toLocaleString(
                                        "de-DE"
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.compensationMaterial.toLocaleString(
                                        "de-DE"
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.compensationSum.toLocaleString(
                                        "de-DE"
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.reservesPerson.toLocaleString(
                                        "de-DE"
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.reservesMaterial.toLocaleString(
                                        "de-DE"
                                      )}
                                    </TableCell>
                                    <TableCell align="right">
                                      {item.reservesSum.toLocaleString("de-DE")}
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </div>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 50]}
                          component="div"
                          count={this.state.list.length}
                          rowsPerPage={this.state.rowsPerPage}
                          page={this.state.page}
                          onPageChange={this.handleChangePage}
                          onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                      </Paper>
                    ) : (
                      <Paper style={{ textAlign: "center", padding: 20 }}>
                        Ingen treff
                      </Paper>
                    )}
                  </Grid>
                </Grid>
              </React.Fragment>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

export default GKCountry;
